var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { getAttributes } from '../../../../../../utils';
import { Image } from '../../../../../atoms/image';
import { Link } from '../../../../../atoms/link';
import { Container, ContainerWidths } from '../../../../../templates/container';
var PCI = function (_a) {
    var fallbackProp = _a.fallback, srcProp = _a.src, altProp = _a.alt, widthProp = _a.width, heightProp = _a.height, _b = _a.aspectRatio, aspectRatioProp = _b === void 0 ? true : _b, renditions = _a.renditions, srcSetData = _a.srcSetData, _c = _a.lazyLoading, lazyLoadingProp = _c === void 0 ? true : _c, fetchPriority = _a.fetchPriority, linkUrl = _a.linkUrl, linkTarget = _a.linkTarget, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onFocus = _a.onFocus, onBlur = _a.onBlur, rest = __rest(_a, ["fallback", "src", "alt", "width", "height", "aspectRatio", "renditions", "srcSetData", "lazyLoading", "fetchPriority", "linkUrl", "linkTarget", "onClick", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"]);
    var linkConfig = {
        linkUrl: linkUrl,
        linkTarget: linkTarget,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        'aria-label': altProp
    };
    var imageConfig = __assign({ src: srcProp || fallbackProp, renditions: renditions, srcSetData: srcSetData, alt: altProp, width: widthProp || '100%', height: heightProp || 'auto', aspectRatio: aspectRatioProp, lazyLoading: lazyLoadingProp, fetchPriority: fetchPriority }, getAttributes(rest));
    return linkUrl ? (React.createElement(Link, __assign({}, linkConfig),
        React.createElement(Container, { width: ContainerWidths.Full },
            React.createElement(Image, __assign({}, imageConfig))))) : (React.createElement(Container, { width: ContainerWidths.Full },
        React.createElement(Image, __assign({}, imageConfig))));
};
export { PCI as ProductCardImage };
